
import { InterviewSubmissionService, InterviewSubmission } from './interviewSubmissionService';

/**
 * Facade for interview submission operations
 */
export class InterviewSubmissionFacade {
  /**
   * Submit an interview response
   */
  static async submitInterviewResponse(submissionData: InterviewSubmission): Promise<{success: boolean, error?: string}> {
    return InterviewSubmissionService.submitInterviewResponse(submissionData);
  }
}
